import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  menu: {
    padding: '5px 0px',
  },
  headerContainer: {
    padding: '6px 12px 6px 12px',
    borderBottom: `1px solid #d9d9d9`,
    marginBottom: '5px',
    display: 'flex',
    justifyContent: 'center',
  },
  header: {
    display: 'flex !important',
    alignItems: 'center !important',
    padding: '2px 8px !important',
    backgroundColor: '#f5f5f5 !important',
    border: '1px solid #d9d9d9 !important',
    borderRadius: '4px !important',
    gap: '6px',
    cursor: 'default',
    margin: '0 !important',
    height: 'auto !important',
    lineHeight: '20px !important',
  },
  headerIcon: {
    color: theme.colors.secondary,
    fontSize: '14px !important',
  },
  headerTitle: {
    fontSize: '12px !important',
    fontWeight: 600,
    color: '#595959 !important',
    userSelect: 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    padding: '2px 15px',
    cursor: 'pointer',

    '&:active': {
      backgroundColor: theme.colors.primaryLight,
    },
    '&:hover': {
      backgroundColor:
        window.sessionStorage.getItem('appState') === 'superUser' ||
        window.sessionStorage.getItem('appState') === 'timeMachine'
          ? `${theme.colors.secondaryLight} !important`
          : '',
    },

    '&:not(.ant-dropdown-menu-item-disabled)': {
      color: theme.colors.text.primary,
    },
    div: {
      background: 'transparent !important',
      padding: 0,
      span: {
        background: 'transparent !important',
        '&:not(.ant-dropdown-menu-title-content)': { paddingTop: '2.5px' },
      },
    },
  },
  itemFocus: {
    span: { display: 'flex', justifyContent: 'center' },
    display: 'flex',
    flexDirection: 'row',
    padding: '2px 5px',
    cursor: 'pointer',
    justifyContent: 'center',

    '&:active': {
      backgroundColor: theme.colors.primaryLight,
    },
  },
  icon: {
    color: theme.colors.secondary,
    fontSize: '16px',
  },
  text: {
    display: 'inline',
    fontSize: '16px',
    padding: '3px 6px',
    userSelect: 'none',
  },
  colorItemContainer: {
    width: '68px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid',
    borderColor: theme.colors.lightGray,
  },
  colorItem: {
    width: '62px',
    height: '22px',
    border: '1px solid',
    borderColor: theme.colors.lightGray,
  },
  icons: {
    fontSize: '20px',
    color: theme.colors.primary,
    transition: '0.3s',
  },
  whiteHeader: {
    color: 'white',
  },
});
